<template>
  <v-card class = "card-curvey">
    <v-dialog 
      v-model = "deleteSampleDialog" 
      width="400">
      <v-card v-if = "selectedSample">
        <v-card-title
          class="headline"
          primary-title>
          Delete <span style="padding-left: 5px; font-size: 70%; font-weight: bold"> {{ sampleSelected.length ? sampleSelected.length : '' }} sample{{ sampleSelected.length > 1 ? 's' : '' }} </span>
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this {{ sampleSelected.length ? sampleSelected.length : '' }} sample{{ sampleSelected.length > 1 ? 's' : '' }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :loading = "loaders.delete"
            color="error"
            outline
            @click="deleteSample">
            Delete
          </v-btn>
          <v-btn
            color = "black"
            class = "white--text"
            @click="deleteSampleDialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout 
      row 
      wrap>
      <h3>Training Phrases</h3>
      <v-flex xs4>
        <!-- <v-text-field
          v-model = "samplesQueries.q"
          placeholder = "Search By Name.."
          entityend-icon = "search"
          outline /> -->
      </v-flex>
      <v-spacer />
      <v-btn
        :disabled = "!sampleSelected || !sampleSelected.length"
        color = "blue-grey"
        class = "nlp-nav-btn"
        small
        outline
        @click = "openDeleteSampleDialog">
        <span 
          class="botter-trash-icon" 
          style="padding-right: 6px"/>
        Delete
      </v-btn>
      <v-btn
        :loading = "!!(loaders.addSample)"
        color = "blue-grey"
        class = "nlp-nav-btn"
        small
        outline
        @click = "submitAddSample">
        <v-icon>add</v-icon>
        New Item
      </v-btn>

    </v-layout>
    <v-flex xs12>
      <v-data-table
        ref = "dataTable"
        v-model="sampleSelected"
        :headers="headers"
        :items="$store.state.nlp.intentSamples"

        item-key="id"
        single-select
        select-all
        hide-actions
        class="elevation-1 nlp-data-table">
        <template 
          slot="items" 
          slot-scope = "props" > 
          <add-intent-sample
            v-if = "props.index === 0"
            ref = "newSampleFull"
            :text-field-props = "{
              class: 'table-text-field',
              outline: true,
              small: true,
              'hide-details': true
            }"
            :container-tag = "{
              name: 'tr',
              props: { class: '' }
            }"
            :parrier-tag = "{
              name: 'td',
              props: { class: '' }
            }"
            :custom-bind = "{ type: { class: 'text-center' } }"
            @success = "handleAddSuccess"
            @loading = "loaders.addSample = $event"
            @submit-attemp = "submitAddSample">
            <td slot = "before-name" />
          </add-intent-sample>
          <tr>
            <td>
              <v-checkbox
                v-model="props.selected"
                primary
                hide-details />
            </td>
            <td>
              <intent-editor :item = "props.item" />
            </td>
            <!-- <td class="text-left">{{ props.item.score }}</td> -->
          </tr>
        </template>
        <add-intent-sample
          slot = "no-data"
          ref = "newSampleEmpty"
          :text-field-props = "{
            class: 'table-text-field full-width',
            outline: true,
            small: true,
            'hide-details': true
          }"
          :container-tag = "{
            name: 'tr',
            props: { class: '' }
          }"
          :parrier-tag = "{
            name: 'td',
            props: { class: '' }
          }"
          :custom-bind = "{ type: { class: 'text-center' }, name: { class: 'add-sample-name' } }"
          @success = "handleAddSuccess"
          @loading = "loaders.addSample = $event"
          @submit-attemp = "submitAddSample">
          <td slot = "before-name" />
        </add-intent-sample>
      </v-data-table>
      <v-divider />
      <v-layout 
        row 
        wrap >
        <v-flex xs11>
          <v-layout 
            justify-center 
            align-content-center 
            style = "padding-top: 15px">
            <v-pagination
              slot = "footer"
              v-model="pagination.page"
              :length="paginationCount"
              style = "width: auto !important; margin: auto !important"
              @input = "changePage" />
          </v-layout>
        </v-flex>
        <v-flex 
          xs1 
          align-self-center>
          <v-spacer />
          <div style="text-align: right"><small>Items Per Page</small></div>
          <v-select
            v-model = "pagination.per_page"
            :items = "[5,10,15,20,25]"
            outline
            @input = "changePage"/>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-card>
</template>

<script>
import IntentEditor from './IntentEditor'
import AddIntentSample from './AddIntentSample'
export default {
  name: 'IntentSamples',
  components: {
    IntentEditor,
    AddIntentSample
  },
  data() {
    return {
      samplesQueries: {
        q: ''
      },
      pagination: {
        page: 1,
        per_page: 5
      },
      sampleSelected: [],
      selectedSample: null,
      deleteSampleDialog: false,
      loaders: {
        addSample: false
      },
      showSamples: false,
      headers: [
        {
          text: 'Normalized Values',
          align: 'left',
          value: 'utterance',
          sortable: false
        },
        // { text: 'Score', value: 'score', align: 'left', sortable: false }
      ]
    }
  },
  computed: {
    queriedIntentSamples() {
      return this.showSamples ? this.$store.state.nlp.intentSamples : []
    },
    paginationCount() {
      return this.queriedIntentSamples && this.queriedIntentSamples.length
        ? Math.ceil(
            this.$store.state.nlp.intentsPagination.samples.count /
              this.pagination.per_page
          )
        : 0
    }
  },
  watch: {
    // sampleSelected: {
    //   deep: true,
    //   handler(val) {
    //     if (val && val.length && val.length > 1) {
    //       this.sampleSelected = [val[val.length - 1]]
    //     }
    //   }
    // }
    pagination: {
      deep: true,
      handler(val) {
        this.asyncLocalStorage(val)
      }
    }
  },
  mounted() {
    this.getIntentSamples()
    this.asyncLocalStorage()
  },
  methods: {
    asyncLocalStorage(payload = null) {
      // if(!payload) {
      //   const stored = window.localStorage.getItem('intentSamplesTable')
      //   if(!stored) {
      //     this.asyncLocalStorage(this.pagination)
      //   } else {
      //     this.pagination = JSON.parse(stored)
      //   }
      // } else {
      //   window.localStorage.setItem('intentSamplesTable', JSON.stringify(payload))
      // }
    },
    forceUpdate() {
      this.$forceUpdate()
    },
    handleUpdatePagination() {
      setTimeout(() => {
        this.$forceUpdate()
        if (this.$refs.dataTable) this.$refs.dataTable.$forceUpdate()
        this.$root.$emit('sample-pagination')
      }, 200)
    },
    handleAddSuccess() {
      this.resetAndGetSamples()
    },
    submitAddSample() {
      this.$refs[
        `newSample${this.queriedIntentSamples.length ? 'Full' : 'Empty'}`
      ].submit()
    },
    async getIntentSamples() {
      this.$store.state.nlp.intentSamples = []
      this.selected = []
      await this.$store
        .dispatch('nlp/intents/samples/get', this.pagination)
        .then(() => {
          this.showSamples = true
        })
    },
    openDeleteSampleDialog() {
      this.selectedSample = this.sampleSelected[0]
      this.deleteSampleDialog = true
    },
    deleteSample() {
      this.$store.dispatch('setLoader', true)
      this.$store
        .dispatch('nlp/intents/samples/delete/multiple', this.sampleSelected)
        .then(() => {
          this.$store.dispatch('setSnackbar', {
            text: `Deleted Successfully`,
            color: 'success'
          })
          this.selected = []
          this.$store.dispatch('setLoader', false)
          this.resetAndGetSamples()
          this.deleteSampleDialog = false
        })
        .catch(err => {
          // console.log(err)
          this.$store.dispatch('setErrorMessage', true)
          this.$store.dispatch('setLoader', false)
        })
    },
    changePage() {
      this.resetAndGetSamples()
    },
    resetAndGetSamples() {
      this.showSamples = false
      setTimeout(() => {
        this.getIntentSamples()
      }, 500)
    }
  }
}
</script>

<style lang="css">
.add-sample-name {
  min-width: 50vw;
}
</style>
